import React from "react";
import Modal from "../../../../components/modal";
import Button from "../../../../components/new-button";
import style from "./style.module.scss";

function ArchiveApp({ open, onClose, onDuplicate }) {
  const canDuplicate = typeof onDuplicate === "function";
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      size="sm"
      withAlert
      headingCentered
      headingCenteredSpaced
      header="Application archived"
    >
      <p className={style.subTitle}>
        App is older than 30 days and has been archived.{" "}
        {canDuplicate
          ? "You can duplicate the app to create a new one."
          : "Please contact your administrator to unarchive."}
      </p>
      {canDuplicate && (
        <div className={style.actionWrapper}>
          <Button variant="primary" onClick={onDuplicate}>
            Duplicate App
          </Button>
        </div>
      )}
    </Modal>
  );
}

export default ArchiveApp;
